// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 847) return "static/chunks/a18f0e56-272654971375ac56.js";
	if (chunkId === 750) return "static/chunks/750-be0b701586a66d45.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"0f44b1f22bdfcb42","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"65568ed7a7b11d4a","367":"6a83bd55d32b4210","639":"0009326f588bf519","748":"dfcb2be73225884c"}[chunkId] + ".js";
};